import {
  EmptyHeader,
  ExtraSummaryMetricHeader,
  MetricHeader,
  SelectionHeader,
  SortableHeader,
  SummaryMetricHeader,
} from 'features/dashboard/table/column/DashboardHeaders'
import {
  MetricCell,
  OnOffCell,
  SelectionCell,
} from 'features/dashboard/table/column/DashboardCells'

import { MetricColumns } from '../../../Columns'

export const selectionColumn = {
  accessor: 'id',
  sticky: 'left',
  Header: SelectionHeader,
  columns: [
    {
      accessor: 'id',
      width: 50,
      Header: EmptyHeader,
      Cell: SelectionCell,
    },
  ],
}

export const statusColumn = {
  accessor: 'status',
  Header: SortableHeader,
  title: 'ON/OFF',
  columns: [
    {
      accessor: 'status',
      width: 91,
      Header: EmptyHeader,
      Cell: OnOffCell,
    },
  ],
}

export const metricColumns = Object.keys(MetricColumns).map(id => ({
  accessor: id,
  Header: MetricHeader,
  columns: [
    {
      accessor: id,
      width: 185,
      Header: SummaryMetricHeader,
      Cell: MetricCell,
    },
  ],
}))

export const extraMetricColumns = Object.keys(MetricColumns).map(id => ({
  accessor: id,
  Header: MetricHeader,
  columns: [
    {
      accessor: id,
      Header: SummaryMetricHeader,
      columns: [
        {
          accessor: id,
          width: 185,
          Header: ExtraSummaryMetricHeader,
          Cell: MetricCell,
        },
      ],
    },
  ],
}))
